"use strict";
exports.__esModule = true;
exports.mapDispatchToCaseChooserProps = exports.mapStateToCaseChooserProps = void 0;
var ui_common_1 = require("@codametrix/ui-common");
var selectCase = ui_common_1.launchPageActions.selectCase;
var mapStateToCaseChooserProps = function (state) {
    return {
        cases: state.codeBench.cases,
        launchParams: state.launch.launchParams
    };
};
exports.mapStateToCaseChooserProps = mapStateToCaseChooserProps;
var mapDispatchToCaseChooserProps = function (dispatch) {
    return {
        chooseCase: function (caseRun) {
            dispatch(selectCase(caseRun));
        }
    };
};
exports.mapDispatchToCaseChooserProps = mapDispatchToCaseChooserProps;
//# sourceMappingURL=case-chooser-component-utilities.js.map